(function () {
  const DESKTOP_QUERY = window.matchMedia('(min-width: 750px)');

  function getSlidesPerView(component) {
    const slider = component.slider;
    if (!slider?.classList.contains('slideshow--dual-desktop')) return 1;

    const desktopCount = parseInt(slider.dataset.slidesPerViewDesktop || '1', 10);
    return DESKTOP_QUERY.matches && desktopCount > 1 ? desktopCount : 1;
  }

  function getPageWidth(component) {
    const slidesPerView = getSlidesPerView(component);
    if (slidesPerView > 1) return component.slider.clientWidth;
    return component.sliderItemOffset || component.slider.clientWidth;
  }

  function getTotalPages(component) {
    const slidesPerView = getSlidesPerView(component);
    if (!component.sliderItemsToShow?.length) return 0;
    return Math.ceil(component.sliderItemsToShow.length / slidesPerView);
  }

  function getCurrentPage(component) {
    const pageWidth = getPageWidth(component);
    if (!pageWidth) return 1;
    return Math.round(component.slider.scrollLeft / pageWidth) + 1;
  }

  function getActiveDotLinks(component) {
    const slidesPerView = getSlidesPerView(component);
    if (slidesPerView > 1) {
      return component.querySelectorAll('.pn-slideshow-dots--page .slider-counter__link');
    }
    return component.querySelectorAll('.pn-slideshow-dots--slide .slider-counter__link');
  }

  function updateSlideVisibility(component) {
    if (!component.sliderItemsToShow?.length) return;

    const slidesPerView = getSlidesPerView(component);
    const currentPage = getCurrentPage(component);
    const startIndex = (currentPage - 1) * slidesPerView;

    component.sliderItemsToShow.forEach((item, index) => {
      const isVisible =
        slidesPerView > 1 ? index >= startIndex && index < startIndex + slidesPerView : index === currentPage - 1;
      const linkElements = item.querySelectorAll('a');

      if (isVisible) {
        linkElements.forEach((button) => button.removeAttribute('tabindex'));
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        linkElements.forEach((button) => button.setAttribute('tabindex', '-1'));
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  function updateDots(component) {
    const currentPage = getCurrentPage(component);
    const totalPages = getTotalPages(component);
    const dotLinks = getActiveDotLinks(component);

    component.querySelectorAll('.slider-counter__link').forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

    dotLinks.forEach((link, index) => {
      const isActive = index + 1 === currentPage;
      if (isActive) {
        link.classList.add('slider-counter__link--active');
        link.setAttribute('aria-current', 'true');
      }
    });

    if (component.currentPageElement && component.pageTotalElement) {
      component.currentPageElement.textContent = currentPage;
      component.pageTotalElement.textContent =
        getSlidesPerView(component) > 1 ? totalPages : component.sliderItemsToShow.length;
    }
  }

  function setPagePosition(component, pageIndex) {
    const pageWidth = getPageWidth(component);
    component.slider.scrollTo({ left: pageIndex * pageWidth });
  }

  function rebindDotNavigation(component) {
    component.querySelectorAll('.pn-slideshow-page-dot').forEach((link) => {
      link.addEventListener('click', (event) => component.linkToSlide(event));
    });

    component.querySelectorAll('.pn-slideshow-dots--slide .slider-counter__link').forEach((link) => {
      link.addEventListener('click', (event) => component.linkToSlide(event));
    });
  }

  function rebindControls(component) {
    component.querySelectorAll('.slideshow__controls').forEach((controls) => {
      controls.replaceWith(controls.cloneNode(true));
    });

    component.querySelectorAll('.pn-slideshow-arrows').forEach((controls) => {
      controls.replaceWith(controls.cloneNode(true));
    });

    component.prevButton = component.querySelector('button[name="previous"]');
    component.nextButton = component.querySelector('button[name="next"]');
    component.sliderControlWrapper = component.querySelector('.slider-buttons');

    component.querySelectorAll('button[name="previous"]').forEach((button) => {
      button.addEventListener('click', (event) => component.onButtonClick(event));
    });

    component.querySelectorAll('button[name="next"]').forEach((button) => {
      button.addEventListener('click', (event) => component.onButtonClick(event));
    });

    const autoplay = component.querySelector('.slideshow__autoplay');
    if (autoplay && component.autoPlayToggle) {
      autoplay.addEventListener('click', () => component.autoPlayToggle());
    }

    rebindDotNavigation(component);
  }

  function enhanceDualSlideshow(component) {
    if (component.dataset.pnDualEnhanced === 'true') return;

    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider?.classList.contains('slideshow--dual-desktop')) return;

    component.dataset.pnDualEnhanced = 'true';

    const originalOnButtonClick = component.onButtonClick.bind(component);
    const originalAutoRotateSlides = component.autoRotateSlides.bind(component);
    const originalSetSlideVisibility = component.setSlideVisibility.bind(component);
    const originalUpdate = component.update.bind(component);

    component.onButtonClick = function (event) {
      if (getSlidesPerView(this) === 1) {
        originalOnButtonClick(event);
        updateSlideVisibility(this);
        updateDots(this);
        return;
      }

      event.preventDefault();
      this.wasClicked = true;

      const totalPages = getTotalPages(this);
      let currentPage = getCurrentPage(this);

      if (event.currentTarget.name === 'next') {
        currentPage = currentPage >= totalPages ? 1 : currentPage + 1;
      } else {
        currentPage = currentPage <= 1 ? totalPages : currentPage - 1;
      }

      setPagePosition(this, currentPage - 1);
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
    };

    component.autoRotateSlides = function () {
      if (getSlidesPerView(this) === 1) {
        originalAutoRotateSlides();
        return;
      }

      const totalPages = getTotalPages(this);
      const currentPage = getCurrentPage(this);
      const nextPageIndex = currentPage >= totalPages ? 0 : currentPage;
      setPagePosition(this, nextPageIndex);
      this.applyAnimationToAnnouncementBar();
    };

    component.setSlideVisibility = function (event) {
      if (getSlidesPerView(this) === 1) {
        originalSetSlideVisibility(event);
        return;
      }

      updateSlideVisibility(this);
      updateDots(this);
      this.wasClicked = false;
    };

    component.update = function () {
      if (getSlidesPerView(this) === 1) {
        originalUpdate();
        return;
      }

      this.currentPage = getCurrentPage(this);
      this.querySelectorAll('button[name="previous"], button[name="next"]').forEach((button) => {
        button.removeAttribute('disabled');
      });
      updateDots(this);
    };

    component.linkToSlide = function (event) {
      if (getSlidesPerView(this) === 1) {
        event.preventDefault();
        const slideLinks = Array.from(this.querySelectorAll('.pn-slideshow-dots--slide .slider-counter__link'));
        const targetIndex = slideLinks.indexOf(event.currentTarget);
        if (targetIndex >= 0) {
          this.slider.scrollTo({ left: targetIndex * this.sliderItemOffset });
        }
        return;
      }

      event.preventDefault();

      const pageIndex = parseInt(event.currentTarget.dataset.pageIndex || '1', 10);
      setPagePosition(this, pageIndex - 1);
    };

    rebindControls(component);

    const handleViewportChange = () => {
      component.resetPages();
      setPagePosition(component, Math.max(getCurrentPage(component) - 1, 0));
      updateSlideVisibility(component);
      updateDots(component);
    };

    if (typeof DESKTOP_QUERY.addEventListener === 'function') {
      DESKTOP_QUERY.addEventListener('change', handleViewportChange);
    } else {
      DESKTOP_QUERY.addListener(handleViewportChange);
    }

    component.slider.addEventListener('scroll', () => {
      if (getSlidesPerView(component) > 1) {
        window.requestAnimationFrame(() => {
          updateSlideVisibility(component);
          updateDots(component);
        });
      }
    });

    updateSlideVisibility(component);
    updateDots(component);
  }

  function initDualSlideshows(root = document) {
    root.querySelectorAll('slideshow-component .slideshow--dual-desktop').forEach((slider) => {
      const component = slider.closest('slideshow-component');
      if (component) enhanceDualSlideshow(component);
    });
  }

  function boot() {
    initDualSlideshows();
    window.requestAnimationFrame(() => initDualSlideshows());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => initDualSlideshows(event.target));
})();
